<template>
  <div
    :class="[
      'sj-paginationTable',
      {
        autoHeight: !fullContainer
      }
    ]"
  >
    <div class="tableBox">
      <SjBaseTable
        ref="table"
        v-bind="$attrs"
        :columns="columns"
        :data="dataFinal"
        :tableProps="tablePropsMerge"
        v-on="tableListeners"
        :iconAsc="iconAsc"
        :iconDesc="iconDesc"
      >
        <slot></slot>
      </SjBaseTable>
    </div>
    <div
      class="paginationBox"
      v-if="totalFinal > 0"
      ref="paginationBox"
      :class="{ background: $slots.default }"
      :style="paginationBoxStyle"
    >
      <SjPagination
        v-bind="$attrs"
        v-model="currentPage"
        :total="totalFinal"
        :pageSize="finalPageSize"
        :pageSizes="pageSizes"
        :pagerCount="pagerCount"
        :background="background"
        :showGoto="showGoto"
        :multi="multi"
        @change="handlePageChange"
        @sizeChange="handleSizeChange"
      />
      <slot></slot>
    </div>
  </div>
</template>

<script>
/**
 * paginationTable封装了表格与分页器组件
 * 支持远程分页和本地分页（async参数为true为远程模式）
 */
import clone from "lodash.clonedeep";

export default {
  name: "SjPaginationTable",
  props: {
    async: {
      type: Boolean,
      default: false
    },
    initGet: {
      type: Boolean,
      default: true
    },
    fullContainer: {
      type: Boolean,
      default: false
    },
    sortMethod: Function,
    sortClearPage: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      default() {
        return [];
      },
      required: true
    },
    data: {
      type: Array,
      default() {
        return [];
      },
      required: true
    },
    tableProps: {
      type: Object,
      default() {
        return {};
      }
    },
    iconAsc: String,
    iconDesc: String,
    total: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 50];
      }
    },
    pagerCount: {
      type: Number,
      default: 7
    },
    background: {
      type: Boolean,
      default: false
    },
    multi: {
      type: Boolean,
      default: false
    },
    showGoto: {
      type: Boolean,
      default: true
    },
    paginationAlign: {
      type: String,
      default: "right"
    },
    restCurrentPage: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      finalPageSize: 10,
      hasListener: false,
      currentPage: 1,
      sortConfig: null,
      dataFinal: []
    };
  },
  computed: {
    paginationBoxStyle() {
      if (this.paginationAlign === "left") {
        return {
          flexDirection: "row",
          justifyContent: "space-between"
        };
      }
      if (this.paginationAlign === "right") {
        return {
          flexDirection: "row-reverse",
          justifyContent: "space-between"
        };
      }
      if (this.paginationAlign === "center") {
        return {
          justifyContent: "center"
        };
      }
      return null;
    },

    tableListeners() {
      const vm = this;
      return Object.assign({}, this.$listeners, {
        "sort-change": val => {
          vm.$emit("sort-change", val);
          if (vm.sortClearPage) {
            vm.currentPage = 1;
          }
          this.handleSortChange(val);
        }
      });
    },
    /**
     * 远程分页时需传入total数据总量
     * 本地分页取data长度作为总量
     */
    totalFinal() {
      const { async, total, data } = this;
      if (async) {
        return total;
      }
      return data.length;
    },
    tablePropsMerge() {
      const { tableProps, fullContainer } = this;
      if (!fullContainer) {
        return tableProps;
      } else {
        return Object.assign({}, tableProps, {
          height: "100%"
        });
      }
    }
  },
  created() {
    if (this.initGet) {
      this.getData();
    }
  },
  methods: {
    /**
     * 页码变更触发数据更新
     */
    handleSizeChange(pageSize) {
      this.currentPage = 1;
      this.finalPageSize = pageSize;
      this.getData();
    },
    handlePageChange(val) {
      this.$emit("pageChange", val);
      this.getData();
    },
    handleSortChange(config) {
      this.sortConfig = config;
      this.getData();
    },
    /**
     * 刷新数据方法
     * 远程分页对外发送事件，由外部更新data
     */
    getData(params) {
      if (this.$refs && this.$refs.table && this.$refs.table.$el) {
        const dom = this.$refs.table.$el.querySelector(".table-body-wrapper");
        if (dom) {
          dom.scrollTop = 0;
        }
      }
      if (this.async) {
        this.$emit(
          "getData",
          this.currentPage,
          this.sortConfig,
          this.finalPageSize,
          params
        );
      } else {
        this.getDataFinal();
      }
    },
    /**
     * 本地分页根据配置切割data获取数据
     */
    getDataFinal() {
      const {
        data,
        async,
        finalPageSize,
        currentPage,
        sortConfig,
        sortMethod
      } = this;
      const originData = clone(data);
      if (async) {
        this.dataFinal = originData;
      } else {
        const params = sortConfig;
        if (params && params.order) {
          originData.sort((a, b) => {
            if (sortMethod) {
              return sortMethod(a, b, params);
            }
            let flag;
            if (a[params.prop] === null || a[params.prop] === undefined) {
              flag = -1;
            } else if (
              b[params.prop] === null ||
              b[params.prop] === undefined
            ) {
              flag = 1;
            } else if (a[params.prop] > b[params.prop]) {
              flag = 1;
            } else if (a[params.prop] < b[params.prop]) {
              flag = -1;
            } else {
              flag = 0;
            }
            if (params.order === "descending") {
              flag = 0 - flag;
            }
            return flag;
          });
        }
        console.log(originData, currentPage, finalPageSize);
        this.dataFinal = originData.slice(
          (currentPage - 1) * finalPageSize,
          currentPage * finalPageSize
        );
        console.log(this.dataFinal);
      }
    },
    clear(params) {
      this.$refs.table.selection = null;
      this.$refs.table.clearSort();
      this.$refs.table.clearFilter();
      this.currentPage = 1;
      this.sortConfig = null;
      this.getData(params);
    }
  },
  watch: {
    fullContainer(val) {
      if (!val) {
        this.runRemoveListener();
      } else {
        this.runAddListener();
      }
    },
    pageSize: {
      immediate: true,
      handler(pageSize) {
        this.finalPageSize = pageSize;
      }
    },
    data: {
      immediate: true,
      deep: true,
      handler() {
        if (!this.async) {
          this.currentPage = 1;
        }
        this.getDataFinal();
      }
    },
    totalFinal() {
      this.currentPage = this.restCurrentPage;
    }
  }
};
</script>

<style lang="less" scoped>
.sj-paginationTable {
  height: 100%;
  display: flex;
  flex-direction: column;
  &.autoHeight {
    height: auto;
    overflow: auto;
  }

  .tableBox {
    flex: 1;
    min-height: 0;
    padding: 0 10px;
    background-color: @pagination-table-tableBox-background-color;
  }

  .paginationBox {
    display: flex;
    align-items: center;
    /*justify-content: center;*/
    padding: 4px 15px;
    background-color: @pagination-table-paginationBox-background-color;
    &.background {
      background-color: @color-gray-1;
    }
  }
}
</style>
